export default "__VITE_ASSET__97f5d16d__"